import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';

import LocalStorage from 'src/utils/LocalStorage';
import { PATH } from 'src/constants/app';

const Restricted: React.FC = () => {
  const authInfo = LocalStorage.authInfo;
  const location = useLocation();

  if (location.pathname === PATH.VERIFICATION) {
    LocalStorage.removeInfo();
    return <Outlet />;
  }

  return authInfo ? <Navigate to={'..'} /> : <Outlet />;
};

export default Restricted;
